import React, { useMemo, useState } from 'react';
import { DataTable } from '../components/DataTable';
import { LoadingBlock } from '../components/LoadingBlock';
import { SectionCard } from '../components/SectionCard';

export function ModerationPage({ loading, error, rooms, selectedRoomId, onSelectRoom, moderationData, users, onApplyModeration, onRemoveRestriction, busy, canManage }) {
  const [form, setForm] = useState({ target_user_id: '', action: 'mute', reason: '', expires_at: '' });
  const selectedRoom = useMemo(() => (rooms || []).find((room) => Number(room.id) === Number(selectedRoomId)) || null, [rooms, selectedRoomId]);
  const restrictions = moderationData?.items || [];

  if (loading) return <LoadingBlock label="Carregando moderação..." />;
  if (error) return <div className="page-error">{error}</div>;

  return (
    <div className="page-grid two-columns">
      <SectionCard title="Salas moderáveis" subtitle="Selecione uma sala para aplicar ou remover restrições.">
        <div className="callout-box compact-box admin-callout">
          <span className="eyebrow">Admin</span>
          <strong>Moderação completa da comunidade</strong>
          <p>Como admin, você denuncia, muta, bane e remove restrições das salas da plataforma, incluindo comunidade, jogo, time e operação.</p>
        </div>

        <DataTable
          rows={rooms || []}
          columns={[
            { key: 'name', label: 'Sala' },
            { key: 'scope', label: 'Escopo' },
            { key: 'messages_count', label: 'Mensagens' },
            {
              key: 'actions',
              label: 'Ação',
              render: (row) => <button className="inline-button" type="button" onClick={() => onSelectRoom(row.id)}>Moderar</button>,
            },
          ]}
          emptyText="Sem salas disponíveis para moderação."
        />
      </SectionCard>

      <SectionCard title="Restrições ativas" subtitle="Mute e ban por sala, com reversão pelo administrador.">
        {selectedRoom ? (
          <>
            <div className="callout-grid admin-summary-grid">
              <div className="callout-box compact-box"><span className="eyebrow">Sala</span><strong>{selectedRoom.name}</strong></div>
              <div className="callout-box compact-box"><span className="eyebrow">Escopo</span><strong>{selectedRoom.scope}</strong></div>
              <div className="callout-box compact-box"><span className="eyebrow">Restrições</span><strong>{restrictions.length}</strong></div>
            </div>

            {canManage ? (
              <form className="admin-form" onSubmit={(event) => {
                event.preventDefault();
                onApplyModeration(selectedRoom.id, {
                  target_user_id: Number(form.target_user_id),
                  action: form.action,
                  reason: form.reason || null,
                  expires_at: form.expires_at || null,
                }).then(() => setForm({ target_user_id: '', action: 'mute', reason: '', expires_at: '' }));
              }}>
                <div className="form-row triple">
                  <label>
                    Usuário
                    <select value={form.target_user_id} onChange={(event) => setForm({ ...form, target_user_id: event.target.value })} required>
                      <option value="">Selecione</option>
                      {(users || []).map((user) => <option key={user.id} value={user.id}>{user.name} • {user.email}</option>)}
                    </select>
                  </label>
                  <label>
                    Ação
                    <select value={form.action} onChange={(event) => setForm({ ...form, action: event.target.value })}>
                      <option value="mute">Mutar</option>
                      <option value="ban">Banir</option>
                    </select>
                  </label>
                  <label>
                    Expira em
                    <input type="datetime-local" value={form.expires_at} onChange={(event) => setForm({ ...form, expires_at: event.target.value })} />
                  </label>
                </div>
                <label>
                  Motivo
                  <input value={form.reason} onChange={(event) => setForm({ ...form, reason: event.target.value })} placeholder="Ex.: spam, ofensa, flood" />
                </label>
                <button className="primary-button" type="submit" disabled={busy || !form.target_user_id}>{busy ? 'Aplicando...' : 'Aplicar restrição'}</button>
              </form>
            ) : null}

            <DataTable
              rows={restrictions}
              columns={[
                { key: 'user_name', label: 'Usuário' },
                { key: 'action', label: 'Ação' },
                { key: 'reason', label: 'Motivo' },
                { key: 'expires_at', label: 'Expira em' },
                { key: 'created_by_name', label: 'Aplicado por' },
                {
                  key: 'actions',
                  label: 'Ação',
                  render: (row) => canManage ? <button className="inline-button danger-text" type="button" onClick={() => onRemoveRestriction(row.id)}>Remover</button> : '-',
                },
              ]}
              emptyText="Sem restrições ativas nesta sala."
            />
          </>
        ) : <div className="empty-state">Selecione uma sala para ver e aplicar moderação.</div>}
      </SectionCard>
    </div>
  );
}
